module.exports = __webpack_public_path__ + "static/img/core1.61925015.png";